// extracted by mini-css-extract-plugin
export default {"base":"DialogError_base__2N-G2","content":"DialogError_content__MJLbH"};